module.exports = __webpack_public_path__ + "img/dataservice_ls.1e7c09fc.png";